import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { AdminApp } from "./admin-app";
import {
  ADMIN_APP_ORIGIN,
  CANONICAL_APP_ORIGIN,
  LEGACY_ADMIN_ORIGINS,
  LEGACY_APP_ORIGINS,
} from "./product.generated";
import "./styles.css";

if (
  import.meta.env.PROD &&
  LEGACY_ADMIN_ORIGINS.includes(
    window.location.origin as (typeof LEGACY_ADMIN_ORIGINS)[number],
  )
) {
  const canonical = new URL(
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
    ADMIN_APP_ORIGIN,
  );
  window.location.replace(canonical.href);
} else if (window.location.origin === ADMIN_APP_ORIGIN) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter>
        <AdminApp />
      </BrowserRouter>
    </StrictMode>,
  );
} else if (
  import.meta.env.PROD &&
  LEGACY_APP_ORIGINS.includes(
    window.location.origin as (typeof LEGACY_APP_ORIGINS)[number],
  )
) {
  const canonical = new URL(
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
    CANONICAL_APP_ORIGIN,
  );
  window.location.replace(canonical.href);
} else {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
